export const START = 'fetch/START'
export const END = 'fetch/END'
export const ERROR = 'fetch/ERROR'
export const CANCEL = 'fetch/CANCEL'



// WEBPACK FOOTER //
// ./state/types/fetch.js